module.exports = __webpack_public_path__ + "img/request-systems.fa19bbbe.png";